module.exports = __webpack_public_path__ + "img/bs_plus_shop_soon.03658af8.jpg";